import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Main from "./main";
import { withFormik } from "formik";
import validationSchema from "./formik/validation-schema";
import initialValues from "./formik/initial-values";
import * as ActionCreators from "./redux/action-creators";
import { addNotification } from "./../../../../../redux/system/system-action-creators";

const mapStateToProps = (state) => {
  return {
    ...state.createUpdateUser,
    memberTye: state.system.userProfile.memberType,
    isFetching: state.system.userProfile.isFetching,
  };
};

const formikEnhancer = withFormik({
  validationSchema: validationSchema,
  mapPropsToValues: () => initialValues,
  handleSubmit: (values, { props }) => {
    const { createUser, updateUser, history } = props;
    values.isEdit ? updateUser(values) : createUser(values, history);
  },
  displayName: "createUpdateUserForm",
});

const enhancedForm = formikEnhancer(Main);

export default withRouter(
  connect(mapStateToProps, { ...ActionCreators, addNotification })(enhancedForm)
);
